export default {
  name: 'MainIndex',
  components: {},
  data: function data() {
    return {};
  },
  methods: {}
};